var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable default-case */
import * as JoinActions from '../../actions/auth/Join';
import * as FastJoinActions from '../../actions/auth/FastJoin';
import * as PasswordActions from '../../actions/createPassword';
import * as JoinStage from '../../constants/JoinStage';
import { phoneJoinType, emailJoinType } from '../../constants/configMap';
import { deleteCookie } from '../../cookiesUtils';
var initialState = {
    registrationModalToggled: false,
    registrationSuccessModalToggled: false,
    emailActivationModalToggled: false,
    thankYouModalToggled: false,
    inProcess: false,
    error: null,
    promoCodeError: null,
    userRegistration: {},
    joinType: undefined,
    joinEmail: undefined,
    joinPhone: undefined,
    joinCountryId: undefined,
    confirmRequestId: undefined,
    passwordStatus: null
};
export default function registration(state, action) {
    if (state === void 0) { state = initialState; }
    if (action === void 0) { action = {}; }
    switch (action.type) {
        case PasswordActions.SUCCESS_CREATE_PASSWORD:
            return __assign(__assign({}, state), { passwordStatus: action.data.ResultState });
        case JoinActions.OPEN_REGISTRATION_MODAL:
            return __assign(__assign({}, state), { registrationModalToggled: true, inProcess: false, error: null, userRegistration: {}, fastJoin: {} });
        case JoinActions.CLOSE_REGISTRATION_MODAL:
            return __assign(__assign({}, state), { registrationModalToggled: false, registrationSuccessModalToggled: false, inProcess: false, error: null, userRegistration: {}, fastJoin: {
                    RequestId: undefined,
                }, joinType: undefined });
        case JoinActions.JOIN:
            return __assign(__assign({}, state), { inProcess: true });
        case JoinActions.SUCCESS_JOIN:
            var inProcess = false;
            var error = null;
            var stage = null;
            var promoCodeError = null;
            if (action.data.ResultState !== 0) {
                switch (action.data.ResultState) {
                    case 1:
                        error = -2;
                        break;
                    case -2:
                        error = -1;
                        break;
                    case -3:
                        error = -5;
                        break;
                    case -5:
                        error = -6; // promo code error
                        promoCodeError = action.data.PromocodeState;
                        break;
                    default:
                        error = -1;
                        break;
                }
                return {
                    registrationModalToggled: true,
                    userRegistration: {},
                    fastJoin: {},
                    inProcess: inProcess,
                    error: error,
                    promoCodeError: promoCodeError
                };
            }
            else {
                var phoneConfirmationNeeded = action.data.PhoneConfirmation;
                var userRegistration = {
                    phone: action.data.Phone,
                    phoneConfirmationNeeded: phoneConfirmationNeeded,
                    gamblerId: action.data.UserId,
                    email: action.data.Code,
                    joinPromoType: action.data.JoinPromoType
                };
                if (phoneConfirmationNeeded === true) {
                    stage = JoinStage.PHONE_CONFIRMATION;
                }
                else {
                    stage = JoinStage.SUCCESS;
                }
                deleteCookie('promo');
                return {
                    registrationModalToggled: false,
                    registrationSuccessModalToggled: true,
                    inProcess: false,
                    fastJoin: {},
                    joinEmail: action.data.Email,
                    userRegistration: userRegistration,
                    error: action.data.ResultState,
                    stage: stage
                };
            }
        case FastJoinActions.FAST_JOIN:
            var joinType = action.data.JoinType || undefined;
            var joinEmail = action.data.JoinData.Email || undefined;
            var joinPhone = action.data.JoinData.Phone || undefined;
            var joinCountryId = action.data.JoinData.CountryId || undefined;
            return __assign(__assign({}, state), { inProcess: true, joinType: joinType, joinEmail: joinEmail, joinPhone: joinPhone, joinCountryId: joinCountryId });
        case FastJoinActions.SUCCESS_FAST_JOIN:
            var fastInProcess = false;
            var fastError = null;
            var fastPromoCodeError = null;
            if (action.data.ResultState !== 0) {
                switch (action.data.ResultState) {
                    case 1:
                        fastError = -2;
                        break;
                    case -2:
                        fastError = -1;
                        break;
                    case -3:
                        fastError = -5;
                        break;
                    case -5:
                        fastError = -6; // promo code error
                        fastPromoCodeError = action.data.PromocodeState;
                        break;
                    default:
                        fastError = -1;
                        break;
                }
                return __assign(__assign({}, state), { registrationModalToggled: true, inProcess: fastInProcess, error: fastError, promoCodeError: fastPromoCodeError });
            }
            else if (action.data.ResultState === 0) {
                deleteCookie('promo');
                if (action.data.RequestId !== undefined && action.data.RequestId !== null && state.joinType === phoneJoinType) {
                    var requestId = action.data.RequestId;
                    return __assign(__assign({}, state), { registrationModalToggled: true, inProcess: true, error: null, confirmRequestId: requestId, stage: JoinStage.PHONE_CONFIRMATION });
                }
                else if (state.joinType === emailJoinType) {
                    return __assign(__assign({}, state), { registrationModalToggled: false, registrationSuccessModalToggled: true, inProcess: fastInProcess, error: fastError, stage: JoinStage.EMAIL_SENT });
                }
            }
            break;
        case FastJoinActions.FAILURE_FAST_JOIN:
            return __assign(__assign({}, state), { inProcess: false, fastJoin: action.data });
        case FastJoinActions.FAST_CONFIRM_PHONE:
            return __assign(__assign({}, state), { error: null });
        case JoinActions.SUCCESS_CONFIRM_JOIN:
            if (action.data.ResultState === 0 && action.data.Promocoderesult < 0) {
                return __assign(__assign({}, state), { promoCodeError: action.data.Promocoderesult });
            }
            return state;
        case FastJoinActions.SUCCESS_FAST_CONFIRM_PHONE:
            if (action.data.ResultState === 0) {
                return __assign(__assign({}, state), { error: null, stage: JoinStage.SUCCESS, promoCodeError: action.data.Promocoderesult < 0 ? action.data.Promocoderesult : null });
            }
            else if (action.data.ResultState !== 0) {
                return __assign(__assign({}, state), { error: action.data.ResultState });
            }
            else if (action.data && action.data.Error) {
                return __assign(__assign({}, state), { error: action.data.Error });
            }
            else {
                return __assign(__assign({}, state), { error: -100 });
            }
        case FastJoinActions.CLOSE_CONFIRM_PHONE_MODAL:
        case FastJoinActions.CLOSE_EMAIL_ACTIVATION_MODAL:
        case FastJoinActions.CLOSE_CONFIRM_PHONE_MODAL_SUCCESS:
        case FastJoinActions.CLOSE_REGISTRATION_SUCCESS_MODAL:
            return initialState;
        case FastJoinActions.ERROR_RESET:
            return __assign(__assign({}, state), { error: null, promoCodeError: null });
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/registration/registrationReducer.js